import React from "react";
import * as Styled from "./Loader.styled";
import { Props } from "./types";

export const Loader: React.FC<Props> = React.memo(({ size = 24 }) => {
    return (
        <Styled.Wrapper>
            <Styled.Loader
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <circle cx="12" cy="12" r="10" />
            </Styled.Loader>
        </Styled.Wrapper>
    );
});

Loader.displayName = "Loader";
